import { identifyAnalyticsUser, trackEvent } from "./client";

export const OnboardingStep = {
  EMAIL_CONFIRMATION: "Email confirmation",
  CONNECT_EXCHANGE: "Connect exchange",
  TRADING_METHOD: "Trading method",
  OVERVIEW: "Overview",
  METHOD_SETTINGS: "Method settings",
} as const;
export type OnboardingStepType = typeof OnboardingStep;
export type OnboardingStepValueType =
  OnboardingStepType[keyof OnboardingStepType];
export const BotType = {
  DCA: "DCA",
  TRADING_VIEW: "TradingView",
  SIGNALS: "Signals",
  GRID: "Grid",
} as const;
export type BotTypeType = typeof BotType;
export type BotTypeValueType = BotTypeType[keyof BotTypeType];
export const BotSource = {
  DISCORD: "discord",
  TELEGRAM: "telegram",
} as const;
export type BotSourceType = typeof BotSource;
export type BotSourceValueType = BotSourceType[keyof BotSourceType];
export const EpUserSubscriptionPlan = {
  TRIAL: "Trial",
  BEGINNER: "Beginner",
  INTERMEDIATE: "Intermediate",
  PRO: "Pro",
  PRE_TRIAL: "Pre-Trial",
  STARTER: "Starter",
  ADVANCED: "Advanced",
  PREMIUM: "Premium",
} as const;
export type EpUserSubscriptionPlanType = typeof EpUserSubscriptionPlan;
export type EpUserSubscriptionPlanValueType =
  EpUserSubscriptionPlanType[keyof EpUserSubscriptionPlanType];
export const ExternalAccountType = {
  DISCORD: "Discord",
  TELEGRAM: "Telegram",
} as const;
export type ExternalAccountTypeType = typeof ExternalAccountType;
export type ExternalAccountTypeValueType =
  ExternalAccountTypeType[keyof ExternalAccountTypeType];
export const SubscriptionInvoiceType = {
  EXTENSION: "Extension",
  UPGRADE: "Upgrade",
  LICENSES: "Licenses",
  NEW: "New",
  SIGNALS_GROUP_EXTENSION: "Signals Group - Extension",
} as const;
export type SubscriptionInvoiceTypeType = typeof SubscriptionInvoiceType;
export type SubscriptionInvoiceTypeValueType =
  SubscriptionInvoiceTypeType[keyof SubscriptionInvoiceTypeType];
export const DcaBotCreateeditOrigin = {
  COPY_AS_IS: "copy as is",
  CREATE: "create",
  EDIT: "edit",
  EDIT_AND_COPY: "edit and copy",
  BULK_EDIT: "bulk edit",
  BULK_CREATE: "bulk create",
} as const;
export type DcaBotCreateeditOriginType = typeof DcaBotCreateeditOrigin;
export type DcaBotCreateeditOriginValueType =
  DcaBotCreateeditOriginType[keyof DcaBotCreateeditOriginType];
export const NotificationPartClicked = {
  NOTIFICATION_BOX: "Notification-Box",
  NOTIFICATION_C2A_BUTTON: "Notification-C2A-Button",
} as const;
export type NotificationPartClickedType = typeof NotificationPartClicked;
export type NotificationPartClickedValueType =
  NotificationPartClickedType[keyof NotificationPartClickedType];
export const TradingMethodCategory = {
  SIGNALS_GROUP_FREE_TRIAL_GROUP: "Signals group - Free trial group",
  SIGNALS_GROUP_MY_GROUP: "Signals group - My group",
  DCA_BOT_TRENDING: "DCA bot - Trending",
  DCA_BOT_LONG_RUNNING: "DCA bot - Long-running",
  DCA_BOT_HIGH_VOLUME: "DCA bot - High Volume",
  SIGNALS_GROUP_FREE_GROUP: "Signals group - Free group",
} as const;
export type TradingMethodCategoryType = typeof TradingMethodCategory;
export type TradingMethodCategoryValueType =
  TradingMethodCategoryType[keyof TradingMethodCategoryType];
export const Platform = {
  TELEGRAM_BOT: "Telegram Bot",
  MOBILE_APP: "Mobile App",
  WEBSITE: "Website",
  SYSTEM: "System",
  APP_OR_WEB: "App or Web",
} as const;
export type PlatformType = typeof Platform;
export type PlatformValueType = PlatformType[keyof PlatformType];
export const SubscriptionInvoicePaymentMethod = {
  PAY_PAL: "PayPal",
  BTC: "BTC",
  LTC: "LTC",
  ETH: "ETH",
  XRP: "XRP",
} as const;
export type SubscriptionInvoicePaymentMethodType =
  typeof SubscriptionInvoicePaymentMethod;
export type SubscriptionInvoicePaymentMethodValueType =
  SubscriptionInvoicePaymentMethodType[keyof SubscriptionInvoicePaymentMethodType];
export const WebsiteOriginTimeOfAction = {
  SIGNALS: "signals",
  ADMIN_PANEL: "admin panel",
} as const;
export type WebsiteOriginTimeOfActionType = typeof WebsiteOriginTimeOfAction;
export type WebsiteOriginTimeOfActionValueType =
  WebsiteOriginTimeOfActionType[keyof WebsiteOriginTimeOfActionType];
export const TradingMethodType = {
  DCA_BOT: "DCA Bot",
  SIGNALS_GROUP: "Signals Group",
} as const;
export type TradingMethodTypeType = typeof TradingMethodType;
export type TradingMethodTypeValueType =
  TradingMethodTypeType[keyof TradingMethodTypeType];
export const MarketsTableView = {
  TOP_GAINERS: "top gainers",
  TOP_LOSERS: "top losers",
  VOLUME: "volume",
  POPULAR_ON_CORNIX: "popular on Cornix",
} as const;
export type MarketsTableViewType = typeof MarketsTableView;
export type MarketsTableViewValueType =
  MarketsTableViewType[keyof MarketsTableViewType];
export const SubscriptionInvoicePlan = {
  BEGINNER: "Beginner",
  INTERMEDIATE: "Intermediate",
  PRO: "Pro",
  STARTER: "Starter",
  ADVANCED: "Advanced",
  PREMIUM: "Premium",
} as const;
export type SubscriptionInvoicePlanType = typeof SubscriptionInvoicePlan;
export type SubscriptionInvoicePlanValueType =
  SubscriptionInvoicePlanType[keyof SubscriptionInvoicePlanType];
export const SignalsAutoTradingConfiguration = {
  DEFAULT_CONFIGURATION: "Default Configuration",
  GROUP_CONFIGURATION: "Group Configuration",
  NONE: "None",
} as const;
export type SignalsAutoTradingConfigurationType =
  typeof SignalsAutoTradingConfiguration;
export type SignalsAutoTradingConfigurationValueType =
  SignalsAutoTradingConfigurationType[keyof SignalsAutoTradingConfigurationType];
export const FollowSignalModalType = {
  CLOSE_TRADE: "Close Trade",
  CREATE_TRADE: "Create Trade",
  UPDATE_TRADE: "Update Trade",
} as const;
export type FollowSignalModalTypeType = typeof FollowSignalModalType;
export type FollowSignalModalTypeValueType =
  FollowSignalModalTypeType[keyof FollowSignalModalTypeType];
export const AmountPerTradeType = {
  FIXED_USD: "Fixed USD",
  FIXED_BTC: "Fixed BTC",
  PERCENTAGE: "Percentage",
  RISK_PERCENTAGE: "Risk Percentage",
} as const;
export type AmountPerTradeTypeType = typeof AmountPerTradeType;
export type AmountPerTradeTypeValueType =
  AmountPerTradeTypeType[keyof AmountPerTradeTypeType];
export interface PortfolioAccountsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  epUserTotalAutoTradingGroupsCount: number | null | undefined;
  epUserTotalAutoTradingGroupsNames: string[] | null | undefined;
  epUserCurrentAutoTradingGroupsCount: number | null | undefined;
  epUserCurrentAutoTradingGroupsNames: string[] | null | undefined;
  epUserGroupsCount: number | null | undefined;
  epUserGroupsNames: string[] | null | undefined;
}
export interface OnboardingMinusLoginViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface TelegramUUIDSentProperties {
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
export interface OnboardingMinusVerifyEmailViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  botSource: BotSourceValueType | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
export interface RegistrationMinusSendVerifyEmailAgainClickedProperties {
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
}
export interface DashboardViewAppWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface MarketplaceViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface SignalsBotMarketplaceGroupSelectedProperties {
  marketplaceGroupId: number;
  marketplaceGroupName: string;
  previousGroupId: number | undefined;
  recommendationPosition: number;
  formContext: "onboarding" | "bot_form";
  marketplaceGroupOffersFreeTrial: boolean;
}
export interface MarketplaceMinusGroupClickedProperties {
  marketplaceGroupAverageRating: number;
  marketplaceGroupPagePosition: number | null | undefined;
  marketplaceGroupReviewsCount: number;
  marketplaceGroupDiscountOffered: number;
  marketplaceGroupOffersFreeTrial: boolean;
  marketplaceGroupDollarSignsCount: number;
  marketplaceGroupId: number;
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface MarketplaceGroupMinusJoinGroupClickedProperties {
  marketplaceGroupAverageRating: number;
  marketplaceGroupPagePosition: number | null | undefined;
  marketplaceGroupReviewsCount: number;
  marketplaceGroupDiscountOffered: number;
  marketplaceGroupOffersFreeTrial: boolean;
  marketplaceGroupDollarSignsCount: number;
  marketplaceGroupId: number;
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface OpenTradesViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  epUserTotalAutoTradingGroupsCount: number | null | undefined;
  epUserTotalAutoTradingGroupsNames: string[] | null | undefined;
  epUserCurrentAutoTradingGroupsCount: number | null | undefined;
  epUserCurrentAutoTradingGroupsNames: string[] | null | undefined;
  epUserGroupsCount: number | null | undefined;
  epUserGroupsNames: string[] | null | undefined;
}
export interface CreateAccountViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  epUserIsOnboarding: boolean;
  botSource: BotSourceValueType | null | undefined;
}
export interface AccountTradingConfigViewProperties {
  clientExchange: string;
}
export interface ConnectExternalAccountViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
export interface ValidateTelegramViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
export interface OnboardingMinusConnectGroupViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  epUserGroupsCount: number;
}
export interface OnboardingMinusGroupConfigurationDetailsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
}
export interface UserLoggedInProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  userId_: string;
  userSystemDarkModeOn: boolean;
  isNewUser: boolean | null | undefined;
  sourceButton: string | null | undefined;
  source: string | null | undefined;
}
export interface UserLoggedOutProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface OnboardingMinusJoinFreeGroupViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface WatchlistMarketsViewWebsiteProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface ClosedTradesViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  epUserTotalAutoTradingGroupsCount: number | null | undefined;
  epUserTotalAutoTradingGroupsNames: string[] | null | undefined;
  epUserCurrentAutoTradingGroupsCount: number | null | undefined;
  epUserCurrentAutoTradingGroupsNames: string[] | null | undefined;
  epUserGroupsCount: number | null | undefined;
  epUserGroupsNames: string[] | null | undefined;
}
export interface PortfolioCoinsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface SignalChannelsViewProperties {
  websiteOriginTimeOfAction: WebsiteOriginTimeOfActionValueType;
}
export interface OpenSignalsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupChannelId: number;
}
export interface ClosedSignalsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupChannelId: number;
}
export interface OneClickFollowSignalClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  groupChannelId: number;
}
export interface UpdateTradeBasedOnSignalClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  groupChannelId: number;
}
export interface CloseTradeBasedOnSignalClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  groupChannelId: number;
}
export interface SignalFollowUpdateCloseModalSubmitActionProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  followSignalModalType: FollowSignalModalTypeValueType;
  groupChannelId: number;
}
export interface SignalDetailsViewClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  groupChannelId: number;
  websiteOriginTimeOfAction: WebsiteOriginTimeOfActionValueType;
}
export interface MiscMinusMessagingPlatformConnectedProperties {
  botSource: BotSourceValueType | null | undefined;
}
export interface InfoTooltipReviewedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  infoTooltipNameAndLocation: string;
  infoTooltipReviewTime: number;
}
export interface BotMinusCreateSaveChangesClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  dcaBotCreateeditOrigin: DcaBotCreateeditOriginValueType;
  botType: BotTypeValueType;
}
export interface BotMinusMyBotsViewWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  botType: BotTypeValueType;
}
export interface DCABotMinusExplorePublicBotsViewWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface DCABotMinusPublicBotCopyViewWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  botRank: number | null | undefined;
}
export interface DCABotMinusCopyBotConfigurationViewClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface DCABotMinusEditBeforeCopyClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface BotMinusBotFormViewWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  dcaBotCreateeditOrigin: DcaBotCreateeditOriginValueType;
  botType: BotTypeValueType;
}
export interface CloseNotificationsClickedProperties {
  notificationsReviewTime: number;
}
export interface NotificationMarkAllAsReadProperties {
  numberOfUnreadNotifications: number;
}
export interface SingleNotificationClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  notificationType: string;
  notificationPartClicked: NotificationPartClickedValueType | null | undefined;
}
export interface DashboardMinusMarketsTableViewChangedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  marketsTableView: MarketsTableViewValueType;
}
export interface PurchasePlanMinusChoosePlanPageViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  subscriptionInvoiceType: SubscriptionInvoiceTypeValueType;
}
export interface PurchasePlanMinusPaymentPageViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  subscriptionInvoiceType: SubscriptionInvoiceTypeValueType;
  subscriptionInvoicePlan: SubscriptionInvoicePlanValueType | null | undefined;
  subscriptionInvoiceDuration: number;
}
export interface PurchasePlanMinusPayButtonClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  subscriptionInvoicePaymentMethod: SubscriptionInvoicePaymentMethodValueType;
  subscriptionInvoiceType: SubscriptionInvoiceTypeValueType;
  subscriptionInvoicePlan: SubscriptionInvoicePlanValueType | null | undefined;
  subscriptionInvoiceDuration: number;
  subscriptionInvoicePrice: number;
}
export interface PurchasePlanMinusDurationPageViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  subscriptionInvoiceType: SubscriptionInvoiceTypeValueType;
  subscriptionInvoicePlan: SubscriptionInvoicePlanValueType | null | undefined;
}
export interface AffiliationMinusReferralLinksViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface AffiliationMinusReferredUsersViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface AffiliationMinusEarningsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface AffiliationMinusPayoutsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface AffiliationMinusNewReferralLinkClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface AffiliationMinusManagePayoutMethodsClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface AffiliationMinusNewPayoutClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface AdminPanelMinusOpenSignalsViewProperties {
  groupChannelId: number;
}
export interface AdminPanelMinusClosedSignalsViewProperties {
  groupChannelId: number;
}
export interface OnboardingMinusConnectToExchangeClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  clientExchange: string;
  createClientIsQuickConnect: boolean | null | undefined;
}
export interface ConnectExchangeTryAgainClickedProperties {
  onboardingStep: OnboardingStepValueType | null | undefined;
  clientExchange: string;
  epUserIsOnboarding: boolean;
}
export interface OnboardingMinusTradingMethodViewedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  botSource: BotSourceValueType | null | undefined;
}
export interface OnboardingMinusOverviewViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  tradingMethodType: TradingMethodTypeValueType;
  marketplaceGroupId: number | null | undefined;
  groupName: string | null | undefined;
  clientExchange: string;
  copiedBotLeverage: number | null | undefined;
  copiedBotSymbol: string | null | undefined;
  epUserIsOnboarding: boolean;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
  botSource: BotSourceValueType | null | undefined;
  botRank: number | null | undefined;
  marketplaceGroupPagePosition: number | null | undefined;
}
export interface OnboardingMinusSkipExternalAccountClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  externalAccountType: ExternalAccountTypeValueType;
}
export interface ConnectToExternalAccountClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
  externalAccountType: ExternalAccountTypeValueType;
}
export interface MissingAGroupClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
export interface OnboardingMinusSelectConfigurationClickProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  signalsAutoTradingConfiguration:
    | SignalsAutoTradingConfigurationValueType
    | null
    | undefined;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
}
export interface OnboardingMinusStartTradingClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  tradingMethodType: TradingMethodTypeValueType;
  signalsAutoTradingConfiguration:
    | SignalsAutoTradingConfigurationValueType
    | null
    | undefined;
  marketplaceGroupId: number | null | undefined;
  marketplaceGroupOffersFreeTrial: boolean | null | undefined;
  groupName: string | null | undefined;
  amountPerTradeType: AmountPerTradeTypeValueType;
  clientExchange: string;
  copiedBotLeverage: number | null | undefined;
  copiedBotSymbol: string | null | undefined;
  epUserIsOnboarding: boolean;
  amountPerTradeIsDefault: boolean | null | undefined;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
  botSource: BotSourceValueType | null | undefined;
  botRank: number | null | undefined;
  marketplaceGroupPagePosition: number | null | undefined;
}
export interface OnboardingMinusStartTradingWarningViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  amountPerTradeType: AmountPerTradeTypeValueType;
  tradingMethodType: TradingMethodTypeValueType;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
}
export interface OnboardingMinusPublicBotsViewProperties {
  epUserIsOnboarding: boolean;
  onboardingStep: OnboardingStepValueType;
}
export interface OnboardingMinusSkippedProperties {
  epUserIsOnboarding: boolean;
  onboardingStep: OnboardingStepValueType;
  tradingMethodType: TradingMethodTypeValueType | null | undefined;
  botSource: BotSourceValueType | null | undefined;
}
export interface AffiliationMinusExistingUsersViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface AffiliationMinusCopyPromoCodeClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
export interface TradingTerminalViewProperties {
  epUserIsDarkMode: boolean;
}
export interface AccountAndGroupsViewProperties {
  epUserIsDarkMode: boolean;
}
export interface SettingsMinusBillingViewProperties {
  epUserIsDarkMode: boolean;
}
export interface SettingsMinusUserSettingsViewProperties {
  epUserIsDarkMode: boolean;
}

const defineEvent =
  <Properties extends object>(
    name: string,
    mapping: Record<string, keyof Properties>,
    nullable: readonly (keyof Properties)[] = [],
    identity?: keyof Properties,
    sendImmediately?: (properties: Properties) => boolean
  ) =>
  (properties: Properties = {} as Properties): void => {
    if (identity && properties[identity])
      identifyAnalyticsUser(String(properties[identity]));
    const payload: Record<string, unknown> = { platform: "Website" };
    for (const [key, field] of Object.entries(mapping)) {
      payload[key] = nullable.includes(field)
        ? properties[field] ?? null
        : properties[field];
    }
    trackEvent(name, payload, sendImmediately?.(properties));
  };

const events = {
  portfolioAccountsView: defineEvent<PortfolioAccountsViewProperties>(
    "Portfolio Accounts View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      ep_user_total_auto_trading_groups_count:
        "epUserTotalAutoTradingGroupsCount",
      ep_user_total_auto_trading_groups_names:
        "epUserTotalAutoTradingGroupsNames",
      ep_user_current_auto_trading_groups_count:
        "epUserCurrentAutoTradingGroupsCount",
      ep_user_current_auto_trading_groups_names:
        "epUserCurrentAutoTradingGroupsNames",
      ep_user_groups_count: "epUserGroupsCount",
      ep_user_groups_names: "epUserGroupsNames",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionPlan",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "epUserTotalAutoTradingGroupsCount",
      "epUserTotalAutoTradingGroupsNames",
      "epUserCurrentAutoTradingGroupsCount",
      "epUserCurrentAutoTradingGroupsNames",
      "epUserGroupsCount",
      "epUserGroupsNames",
    ]
  ),
  telegramUuidSent: defineEvent<TelegramUUIDSentProperties>(
    "Telegram UUID Sent",
    {
      onboarding_step: "onboardingStep",
      ep_user_is_onboarding: "epUserIsOnboarding",
    },
    ["onboardingStep"]
  ),
  onboardingVerifyEmailView:
    defineEvent<OnboardingMinusVerifyEmailViewProperties>(
      "Onboarding - Verify Email View",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        bot_source: "botSource",
        onboarding_step: "onboardingStep",
        ep_user_is_onboarding: "epUserIsOnboarding",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
        "botSource",
        "onboardingStep",
      ]
    ),
  registrationSendVerifyEmailAgainClicked:
    defineEvent<RegistrationMinusSendVerifyEmailAgainClickedProperties>(
      "Registration - Send Verify Email Again Clicked",
      {
        onboarding_step: "onboardingStep",
        ep_user_is_onboarding: "epUserIsOnboarding",
      },
      []
    ),
  dashboardViewAppWeb: defineEvent<DashboardViewAppWebProperties>(
    "Dashboard View (App & Web)",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  signalsBotMarketplaceGroupSelected:
    defineEvent<SignalsBotMarketplaceGroupSelectedProperties>(
      "Signals Bot - Marketplace Group Selected",
      {
        marketplace_group_id: "marketplaceGroupId",
        marketplace_group_name: "marketplaceGroupName",
        previous_group_id: "previousGroupId",
        recommendation_position: "recommendationPosition",
        form_context: "formContext",
        marketplace_group_offers_free_trial: "marketplaceGroupOffersFreeTrial",
      },
      ["previousGroupId"]
    ),
  marketplaceGroupClicked: defineEvent<MarketplaceMinusGroupClickedProperties>(
    "Marketplace - Group Clicked",
    {
      marketplace_group_average_rating: "marketplaceGroupAverageRating",
      marketplace_group_page_position: "marketplaceGroupPagePosition",
      marketplace_group_reviews_count: "marketplaceGroupReviewsCount",
      marketplace_group_discount_offered: "marketplaceGroupDiscountOffered",
      marketplace_group_offers_free_trial: "marketplaceGroupOffersFreeTrial",
      marketplace_group_dollar_signs_count: "marketplaceGroupDollarSignsCount",
      marketplace_group_id: "marketplaceGroupId",
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
    },
    [
      "marketplaceGroupPagePosition",
      "epUserSubscriptionDuration",
      "epUserSubscriptionPlan",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  marketplaceGroupJoinGroupClicked:
    defineEvent<MarketplaceGroupMinusJoinGroupClickedProperties>(
      "Marketplace Group - Join Group Clicked",
      {
        marketplace_group_average_rating: "marketplaceGroupAverageRating",
        marketplace_group_page_position: "marketplaceGroupPagePosition",
        marketplace_group_reviews_count: "marketplaceGroupReviewsCount",
        marketplace_group_discount_offered: "marketplaceGroupDiscountOffered",
        marketplace_group_offers_free_trial: "marketplaceGroupOffersFreeTrial",
        marketplace_group_dollar_signs_count:
          "marketplaceGroupDollarSignsCount",
        marketplace_group_id: "marketplaceGroupId",
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "marketplaceGroupPagePosition",
        "epUserSubscriptionDuration",
        "epUserSubscriptionPlan",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  openTradesView: defineEvent<OpenTradesViewProperties>(
    "Open Trades View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      ep_user_total_auto_trading_groups_count:
        "epUserTotalAutoTradingGroupsCount",
      ep_user_total_auto_trading_groups_names:
        "epUserTotalAutoTradingGroupsNames",
      ep_user_current_auto_trading_groups_count:
        "epUserCurrentAutoTradingGroupsCount",
      ep_user_current_auto_trading_groups_names:
        "epUserCurrentAutoTradingGroupsNames",
      ep_user_groups_count: "epUserGroupsCount",
      ep_user_groups_names: "epUserGroupsNames",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionPlan",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "epUserTotalAutoTradingGroupsCount",
      "epUserTotalAutoTradingGroupsNames",
      "epUserCurrentAutoTradingGroupsCount",
      "epUserCurrentAutoTradingGroupsNames",
      "epUserGroupsCount",
      "epUserGroupsNames",
    ]
  ),
  createAccountView: defineEvent<CreateAccountViewProperties>(
    "Create Account View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      ep_user_is_onboarding: "epUserIsOnboarding",
      bot_source: "botSource",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "botSource",
    ]
  ),
  resetPasswordView: defineEvent<Record<string, never>>(
    "Reset Password View",
    {},
    []
  ),
  connectExternalAccountView: defineEvent<ConnectExternalAccountViewProperties>(
    "Connect External Account View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      onboarding_step: "onboardingStep",
      ep_user_is_onboarding: "epUserIsOnboarding",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "onboardingStep",
    ]
  ),
  validateTelegramView: defineEvent<ValidateTelegramViewProperties>(
    "Validate Telegram View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      onboarding_step: "onboardingStep",
      ep_user_is_onboarding: "epUserIsOnboarding",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "onboardingStep",
    ]
  ),
  onboardingConnectGroupView:
    defineEvent<OnboardingMinusConnectGroupViewProperties>(
      "Onboarding - Connect Group View",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        onboarding_step: "onboardingStep",
        ep_user_is_onboarding: "epUserIsOnboarding",
        ep_user_groups_count: "epUserGroupsCount",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  userLoggedIn: defineEvent<UserLoggedInProperties>(
    "User Logged In",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      user_system_dark_mode_on: "userSystemDarkModeOn",
      is_new_user: "isNewUser",
      source_button: "sourceButton",
      source: "source",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionPlan",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "isNewUser",
      "sourceButton",
      "source",
    ],
    "userId_"
  ),
  userLoggedOut: defineEvent<UserLoggedOutProperties>(
    "User Logged Out",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionPlan",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  watchlistMarketsViewWebsite:
    defineEvent<WatchlistMarketsViewWebsiteProperties>(
      "Watchlist / Markets View (Website)",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionPlan",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  closedTradesView: defineEvent<ClosedTradesViewProperties>(
    "Closed Trades View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      ep_user_total_auto_trading_groups_count:
        "epUserTotalAutoTradingGroupsCount",
      ep_user_total_auto_trading_groups_names:
        "epUserTotalAutoTradingGroupsNames",
      ep_user_current_auto_trading_groups_count:
        "epUserCurrentAutoTradingGroupsCount",
      ep_user_current_auto_trading_groups_names:
        "epUserCurrentAutoTradingGroupsNames",
      ep_user_groups_count: "epUserGroupsCount",
      ep_user_groups_names: "epUserGroupsNames",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionPlan",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "epUserTotalAutoTradingGroupsCount",
      "epUserTotalAutoTradingGroupsNames",
      "epUserCurrentAutoTradingGroupsCount",
      "epUserCurrentAutoTradingGroupsNames",
      "epUserGroupsCount",
      "epUserGroupsNames",
    ]
  ),
  portfolioCoinsView: defineEvent<PortfolioCoinsViewProperties>(
    "Portfolio Coins View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionPlan",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  openSignalsView: defineEvent<OpenSignalsViewProperties>(
    "Open Signals View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      group_channel_id: "groupChannelId",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  closedSignalsView: defineEvent<ClosedSignalsViewProperties>(
    "Closed Signals View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      group_channel_id: "groupChannelId",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  oneClickFollowSignalClicked:
    defineEvent<OneClickFollowSignalClickedProperties>(
      "One Click Follow Signal Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        group_signal_id: "groupSignalId",
        group_channel_id: "groupChannelId",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  updateTradeBasedOnSignalClicked:
    defineEvent<UpdateTradeBasedOnSignalClickedProperties>(
      "Update Trade Based on Signal Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        group_signal_id: "groupSignalId",
        group_channel_id: "groupChannelId",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  closeTradeBasedOnSignalClicked:
    defineEvent<CloseTradeBasedOnSignalClickedProperties>(
      "Close Trade Based on Signal Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        group_signal_id: "groupSignalId",
        group_channel_id: "groupChannelId",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  signalFollowupdatecloseModalSubmitAction:
    defineEvent<SignalFollowUpdateCloseModalSubmitActionProperties>(
      "Signal Follow/Update/Close Modal Submit Action",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        group_signal_id: "groupSignalId",
        follow_signal_modal_type: "followSignalModalType",
        group_channel_id: "groupChannelId",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  signalDetailsViewClicked: defineEvent<SignalDetailsViewClickedProperties>(
    "Signal Details View Clicked",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      group_signal_id: "groupSignalId",
      group_channel_id: "groupChannelId",
      website_origin_time_of_action: "websiteOriginTimeOfAction",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  infoTooltipReviewed: defineEvent<InfoTooltipReviewedProperties>(
    "Info Tooltip Reviewed",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      info_tooltip_name_and_location: "infoTooltipNameAndLocation",
      info_tooltip_review_time: "infoTooltipReviewTime",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  botCreateSaveChangesClicked:
    defineEvent<BotMinusCreateSaveChangesClickedProperties>(
      "Bot - Create / Save Changes Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        "dca_bot_create/edit_origin": "dcaBotCreateeditOrigin",
        bot_type: "botType",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  botMyBotsViewWeb: defineEvent<BotMinusMyBotsViewWebProperties>(
    "Bot - My Bots View (Web)",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      bot_type: "botType",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  dcaBotExplorePublicBotsViewWeb:
    defineEvent<DCABotMinusExplorePublicBotsViewWebProperties>(
      "DCA Bot - Explore Public Bots View (Web)",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  dcaBotPublicBotCopyViewWeb:
    defineEvent<DCABotMinusPublicBotCopyViewWebProperties>(
      "DCA Bot - Public Bot Copy View (Web)",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        bot_rank: "botRank",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
        "botRank",
      ]
    ),
  dcaBotCopyBotConfigurationViewClicked:
    defineEvent<DCABotMinusCopyBotConfigurationViewClickedProperties>(
      "DCA Bot - Copy Bot Configuration View Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  dcaBotEditBeforeCopyClicked:
    defineEvent<DCABotMinusEditBeforeCopyClickedProperties>(
      "DCA Bot - Edit Before Copy Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  botBotFormViewWeb: defineEvent<BotMinusBotFormViewWebProperties>(
    "Bot - Bot Form View (Web)",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      "dca_bot_create/edit_origin": "dcaBotCreateeditOrigin",
      bot_type: "botType",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  showNotificationsClicked: defineEvent<Record<string, never>>(
    "Show Notifications Clicked",
    {},
    []
  ),
  closeNotificationsClicked: defineEvent<CloseNotificationsClickedProperties>(
    "Close Notifications Clicked",
    { notifications_review_time: "notificationsReviewTime" },
    []
  ),
  notificationMarkAllAsRead: defineEvent<NotificationMarkAllAsReadProperties>(
    "Notification Mark All as Read",
    { "number of unread notifications": "numberOfUnreadNotifications" },
    []
  ),
  singleNotificationClicked: defineEvent<SingleNotificationClickedProperties>(
    "Single Notification Clicked",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      notification_type: "notificationType",
      notification_part_clicked: "notificationPartClicked",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "notificationPartClicked",
    ]
  ),
  dashboardMarketsTableViewChanged:
    defineEvent<DashboardMinusMarketsTableViewChangedProperties>(
      "Dashboard - Markets Table View Changed",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        markets_table_view: "marketsTableView",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  purchasePlanChoosePlanPageView:
    defineEvent<PurchasePlanMinusChoosePlanPageViewProperties>(
      "Purchase Plan - Choose Plan Page View",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        subscription_invoice_type: "subscriptionInvoiceType",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  purchasePlanDurationPageView:
    defineEvent<PurchasePlanMinusDurationPageViewProperties>(
      "Purchase Plan - Duration Page View",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        subscription_invoice_type: "subscriptionInvoiceType",
        subscription_invoice_plan: "subscriptionInvoicePlan",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
        "subscriptionInvoicePlan",
      ]
    ),
  affiliationReferralLinksView:
    defineEvent<AffiliationMinusReferralLinksViewProperties>(
      "Affiliation - Referral Links View",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  affiliationReferredUsersView:
    defineEvent<AffiliationMinusReferredUsersViewProperties>(
      "Affiliation - Referred Users View",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  affiliationEarningsView: defineEvent<AffiliationMinusEarningsViewProperties>(
    "Affiliation - Earnings View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  affiliationPayoutsView: defineEvent<AffiliationMinusPayoutsViewProperties>(
    "Affiliation - Payouts View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
    ]
  ),
  affiliationNewReferralLinkClicked:
    defineEvent<AffiliationMinusNewReferralLinkClickedProperties>(
      "Affiliation - New Referral Link Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  affiliationNewPayoutClicked:
    defineEvent<AffiliationMinusNewPayoutClickedProperties>(
      "Affiliation - New Payout Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  adminPanelOpenSignalsView:
    defineEvent<AdminPanelMinusOpenSignalsViewProperties>(
      "Admin Panel - Open Signals View",
      { group_channel_id: "groupChannelId" },
      []
    ),
  adminPanelGroupManagementUsersView: defineEvent<Record<string, never>>(
    "Admin Panel - Group Management Users View",
    {},
    []
  ),
  adminPanelGroupManagementInvitationsView: defineEvent<Record<string, never>>(
    "Admin Panel - Group Management Invitations View",
    {},
    []
  ),
  adminPanelGroupManagementConfigurationsView: defineEvent<
    Record<string, never>
  >("Admin Panel - Group Management Configurations View", {}, []),
  adminPanelClosedSignalsView:
    defineEvent<AdminPanelMinusClosedSignalsViewProperties>(
      "Admin Panel - Closed Signals View",
      { group_channel_id: "groupChannelId" },
      []
    ),
  onboardingConnectToExchangeClicked:
    defineEvent<OnboardingMinusConnectToExchangeClickedProperties>(
      "Onboarding - Connect to Exchange Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        onboarding_step: "onboardingStep",
        ep_user_is_onboarding: "epUserIsOnboarding",
        client_exchange: "clientExchange",
        create_client_is_quick_connect: "createClientIsQuickConnect",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
        "createClientIsQuickConnect",
      ],
      undefined,
      (properties) => properties.createClientIsQuickConnect === true
    ),
  connectExchangeTryAgainClicked:
    defineEvent<ConnectExchangeTryAgainClickedProperties>(
      "Connect Exchange Try Again Clicked",
      {
        onboarding_step: "onboardingStep",
        client_exchange: "clientExchange",
        ep_user_is_onboarding: "epUserIsOnboarding",
      },
      ["onboardingStep"]
    ),
  onboardingTradingMethodViewed:
    defineEvent<OnboardingMinusTradingMethodViewedProperties>(
      "Onboarding - Trading Method Viewed",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        onboarding_step: "onboardingStep",
        ep_user_is_onboarding: "epUserIsOnboarding",
        bot_source: "botSource",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
        "botSource",
      ]
    ),
  onboardingOverviewView: defineEvent<OnboardingMinusOverviewViewProperties>(
    "Onboarding - Overview View",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      onboarding_step: "onboardingStep",
      trading_method_type: "tradingMethodType",
      marketplace_group_id: "marketplaceGroupId",
      group_name: "groupName",
      client_exchange: "clientExchange",
      copied_bot_leverage: "copiedBotLeverage",
      copied_bot_symbol: "copiedBotSymbol",
      ep_user_is_onboarding: "epUserIsOnboarding",
      trading_method_category: "tradingMethodCategory",
      bot_source: "botSource",
      bot_rank: "botRank",
      marketplace_group_page_position: "marketplaceGroupPagePosition",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "marketplaceGroupId",
      "groupName",
      "copiedBotLeverage",
      "copiedBotSymbol",
      "tradingMethodCategory",
      "botSource",
      "botRank",
      "marketplaceGroupPagePosition",
    ]
  ),
  onboardingSkipExternalAccountClicked:
    defineEvent<OnboardingMinusSkipExternalAccountClickedProperties>(
      "Onboarding - Skip External Account Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        onboarding_step: "onboardingStep",
        ep_user_is_onboarding: "epUserIsOnboarding",
        external_account_type: "externalAccountType",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  connectToExternalAccountClicked:
    defineEvent<ConnectToExternalAccountClickedProperties>(
      "Connect to External Account Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        onboarding_step: "onboardingStep",
        ep_user_is_onboarding: "epUserIsOnboarding",
        external_account_type: "externalAccountType",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
        "onboardingStep",
      ]
    ),
  missingAGroupClicked: defineEvent<MissingAGroupClickedProperties>(
    "Missing a Group Clicked",
    {
      ep_user_subscription_duration: "epUserSubscriptionDuration",
      ep_user_subscription_plan: "epUserSubscriptionPlan",
      ep_user_subscription_is_active: "epUserSubscriptionIsActive",
      ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
      ep_user_is_admin: "epUserIsAdmin",
      ep_user_is_telegram_connected: "epUserIsTelegramConnected",
      ep_user_is_discord_connected: "epUserIsDiscordConnected",
      ep_user_feature_flags: "epUserFeatureFlags",
      ep_user_is_dark_mode: "epUserIsDarkMode",
      is_telegram_mini_app: "isTelegramMiniApp",
      onboarding_step: "onboardingStep",
      ep_user_is_onboarding: "epUserIsOnboarding",
    },
    [
      "epUserSubscriptionDuration",
      "epUserSubscriptionIsActive",
      "epUserIsMobileAppUser",
      "epUserIsAdmin",
      "epUserIsTelegramConnected",
      "epUserIsDiscordConnected",
      "epUserFeatureFlags",
      "epUserIsDarkMode",
      "isTelegramMiniApp",
      "onboardingStep",
    ]
  ),
  onboardingStartTradingClicked:
    defineEvent<OnboardingMinusStartTradingClickedProperties>(
      "Onboarding - Start Trading Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        onboarding_step: "onboardingStep",
        trading_method_type: "tradingMethodType",
        signals_auto_trading_configuration: "signalsAutoTradingConfiguration",
        marketplace_group_id: "marketplaceGroupId",
        marketplace_group_offers_free_trial: "marketplaceGroupOffersFreeTrial",
        group_name: "groupName",
        amount_per_trade_type: "amountPerTradeType",
        client_exchange: "clientExchange",
        copied_bot_leverage: "copiedBotLeverage",
        copied_bot_symbol: "copiedBotSymbol",
        ep_user_is_onboarding: "epUserIsOnboarding",
        amount_per_trade_is_default: "amountPerTradeIsDefault",
        trading_method_category: "tradingMethodCategory",
        bot_source: "botSource",
        bot_rank: "botRank",
        marketplace_group_page_position: "marketplaceGroupPagePosition",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
        "signalsAutoTradingConfiguration",
        "marketplaceGroupId",
        "marketplaceGroupOffersFreeTrial",
        "groupName",
        "copiedBotLeverage",
        "copiedBotSymbol",
        "amountPerTradeIsDefault",
        "tradingMethodCategory",
        "botSource",
        "botRank",
        "marketplaceGroupPagePosition",
      ]
    ),
  onboardingStartTradingWarningView:
    defineEvent<OnboardingMinusStartTradingWarningViewProperties>(
      "Onboarding - Start Trading Warning View",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
        onboarding_step: "onboardingStep",
        ep_user_is_onboarding: "epUserIsOnboarding",
        amount_per_trade_type: "amountPerTradeType",
        trading_method_type: "tradingMethodType",
        trading_method_category: "tradingMethodCategory",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
        "tradingMethodCategory",
      ]
    ),
  onboardingPublicBotsView:
    defineEvent<OnboardingMinusPublicBotsViewProperties>(
      "Onboarding - Public Bots View",
      {
        ep_user_is_onboarding: "epUserIsOnboarding",
        onboarding_step: "onboardingStep",
      },
      []
    ),
  onboardingSkipped: defineEvent<OnboardingMinusSkippedProperties>(
    "Onboarding - Skipped",
    {
      ep_user_is_onboarding: "epUserIsOnboarding",
      onboarding_step: "onboardingStep",
      trading_method_type: "tradingMethodType",
      bot_source: "botSource",
    },
    ["tradingMethodType", "botSource"]
  ),
  affiliationExistingUsersView:
    defineEvent<AffiliationMinusExistingUsersViewProperties>(
      "Affiliation - Existing Users View",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  affiliationCopyPromoCodeClicked:
    defineEvent<AffiliationMinusCopyPromoCodeClickedProperties>(
      "Affiliation - Copy Promo Code Clicked",
      {
        ep_user_subscription_duration: "epUserSubscriptionDuration",
        ep_user_subscription_plan: "epUserSubscriptionPlan",
        ep_user_subscription_is_active: "epUserSubscriptionIsActive",
        ep_user_is_mobile_app_user: "epUserIsMobileAppUser",
        ep_user_is_admin: "epUserIsAdmin",
        ep_user_is_telegram_connected: "epUserIsTelegramConnected",
        ep_user_is_discord_connected: "epUserIsDiscordConnected",
        ep_user_feature_flags: "epUserFeatureFlags",
        ep_user_is_dark_mode: "epUserIsDarkMode",
        is_telegram_mini_app: "isTelegramMiniApp",
      },
      [
        "epUserSubscriptionDuration",
        "epUserSubscriptionIsActive",
        "epUserIsMobileAppUser",
        "epUserIsAdmin",
        "epUserIsTelegramConnected",
        "epUserIsDiscordConnected",
        "epUserFeatureFlags",
        "epUserIsDarkMode",
        "isTelegramMiniApp",
      ]
    ),
  tradingTerminalView: defineEvent<TradingTerminalViewProperties>(
    "Trading Terminal View",
    { ep_user_is_dark_mode: "epUserIsDarkMode" },
    []
  ),
  settingsBillingView: defineEvent<SettingsMinusBillingViewProperties>(
    "Settings  - Billing View",
    { ep_user_is_dark_mode: "epUserIsDarkMode" },
    []
  ),
  settingsUserSettingsView:
    defineEvent<SettingsMinusUserSettingsViewProperties>(
      "Settings - User Settings View",
      { ep_user_is_dark_mode: "epUserIsDarkMode" },
      []
    ),
};

export default events;
